import { IdentifierType } from '@weave/schema-gen-ts/dist/schemas/notification/v1/notification_api.pb';
import { NotificationType } from '@weave/schema-gen-ts/dist/shared/notification/notifications.pb';
import { NotificationQueries } from '@frontend/api-notifications';

export const useScheduleRequestNotificationsAsRead = () => {
  const markAsReadMutation = NotificationQueries.useMarkNotificationsAsRead();

  const markNotificationsAsRead = (requestId: string) => {
    //Mark notification as Read for all the users on the location
    markAsReadMutation.mutate({
      notificationType: NotificationType.SCHEDULE_REQUEST,
      identifiers: [
        {
          key: 'id',
          val: requestId,
          type: IdentifierType.STRING,
        },
      ],
    });
  };

  return { markNotificationsAsRead };
};
